import Calendar from "components/calendar";
import Section from "components/section";
import Ui from "components/ui";
import React, { ReactElement } from "react";
import { connect } from "react-redux";
import { Controller } from "react-hook-form";
import { Direction, PostType } from "models/enums";
import { FIELDS, getDateString } from "utils";
import BasePage from "../base-page";
import { usePostForm } from "./hooks";

const selectItems = Object.entries(PostType).map(([key, value]) => ({ key, value }));

const PublishPage: React.FC = (): ReactElement => {
  const {
    control,
    image,
    imageAlt,
    isSubmissionDisabled,
    onFileChange,
    onPostClick,
    onSubmit,
    register,
    selectedDate,
    thumbnail,
  } = usePostForm();
  return (
    <BasePage>
      <form {...{ onSubmit }}>
        <Section centered>
          <Ui.Text
            label="name"
            register={register}
            options={{
              maxLength: FIELDS.MAX.NAME,
              minLength: FIELDS.MIN.NAME,
              required: true,
            }}
            placeholder="Name your post."
          />
          <Ui.TextArea
            label="body"
            register={register}
            options={{
              minLength: FIELDS.MIN.BODY,
              required: true,
            }}
            placeholder="Describe your post."
          />
          <Ui.Select
            control={control}
            items={selectItems}
            label="type"
            rules={{
              required: true,
              validate: (value: string) => (
                !!selectItems.find((i: { value: PostType }) => value === i.value)
              ),
            }}
          />
          <Ui.File
            hasImage={!!image.length}
            id="post_image"
            label="image"
            options={{
              onChange: onFileChange,
              required: true,
            }}
            register={register}
          />
          <Ui.Text
            label="imageAlt"
            register={register}
            options={{
              maxLength: FIELDS.MAX.IMAGE_ALT,
              minLength: FIELDS.MIN.IMAGE_ALT,
              required: true,
            }}
            placeholder="Describe your image."
          />
        </Section>
        <Section centered direction={Direction.ROW} >
          <Controller
            control={control}
            name="selectedDate"
            render={({ field: { onChange, value } }) => (
              <Calendar
                onSelect={({ day, month, year }) => (
                  onChange(new Date(year, month - 1, day))
                )}
                selectedDate={value}
              />
            )}
          />
          <Ui.Card
            entityId="new-id"
            imgAlt={imageAlt}
            imgBlob={thumbnail}
            label={getDateString(selectedDate)}
            onClick={onPostClick}
          />
        </Section>
        <Section centered>  
          <Ui.Submit disabled={isSubmissionDisabled} />
        </Section>
      </form>
    </BasePage>
  );
};

export default connect()(PublishPage);
